var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('q-scroll-area',{staticClass:"fullscreen",attrs:{"dark":"","id":"app-scroll","bar-style":_vm.$q.platform.is.mobile ? { width: '0px' } : undefined,"thumb-style":_vm.$q.platform.is.mobile ? { width: '0px' } : undefined},on:{"scroll":_vm.onAppScroll}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }